exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".style-font-select-wrapper-3skYl{justify-content:space-between;margin-bottom:12px}.style-font-select-wrapper-3skYl,.style-subtitle-2gNaS{font-size:14px;width:100%;height:36px;display:flex;flex-direction:row;align-items:center}.style-subtitle-2gNaS{color:rgba(0,0,0,.48);grid-gap:8px;gap:8px}.style-font-select-2L3hV{width:240px;height:36px}.style-list-container-1pRjz [class^=\"dui-menu dui-menu-normal dui-select-list\"]{border:none;overflow-y:hidden}", ""]);

// Exports
exports.locals = {
	"font-select-wrapper": "style-font-select-wrapper-3skYl",
	"subtitle": "style-subtitle-2gNaS",
	"font-select": "style-font-select-2L3hV",
	"list-container": "style-list-container-1pRjz"
};